import Vue from 'vue';
import defaultState from './state';

const GET_TRANSLATED_TEXT = (state, translation) => {
  state.translation = translation;
};

const GET_TRANSCRIBED_TEXT = (state, transcribe) => {
  state.transcribedText = transcribe;
};

const GET_BOT_RESPONSE = (state, botmsg) => {
  state.botmsg = botmsg;
};

const GET_TEACHBOT_GROUPS_SKELETON_RESPONSE = (state, teachbotGroups) => {
  teachbotGroups.forEach((group, index) => {
    if (state.teachbotGroups[index] === undefined) {
      state.teachbotGroups.push(group);
    }
  });
};

const GET_TEACHBOT_GROUPS_RESPONSE = (state, teachbotGroups) => {
  state.teachbotGroups[teachbotGroups.level].lessonGroups =
    teachbotGroups.lessonGroups;
};

// it should be a skeleton mutations
const GET_GRAMMAR_GROUPS_SKELETON_RESPONSE = (state, grammarGroups) => {
  // foreach on the response groups and set the isSkeleton property to true
  // if there is data or if the isSkeleton is false do nothing with that group
  // you should overwrite the data by level
  grammarGroups.forEach((group) => {
    const groupIndex = group.level;
    if (state.grammarGroups[groupIndex] === undefined) {
      /* eslint-disable-next-line */
      state.grammarGroups[groupIndex] = group;
    }
  });
};

const CLEAR_GRAMMAR_GROUPS = (state) => {
  state.grammarGroups = [];
};
// implement a different mutation for real response data
// check the isSkeleton property, overwrite the data and set the flag false
const GET_GRAMMAR_GROUPS_RESPONSE = (state, grammarGroup) => {
  const groupIndex = grammarGroup.level;
  state.grammarGroups[groupIndex] = grammarGroup;
};

const GET_ISLAND_PROGRESSION = (state, islandProgression) => {
  state.islandProgression = islandProgression;
};

const GET_THEMATICS = (state, thematics) => {
  state.thematics = thematics;
};

const GET_THEMATICS_BY_LEVEL = (state, thematicsByLevel) => {
  state.thematicsByLevel = thematicsByLevel;
};

const GET_LESSON = (state, lesson) => {
  state.lesson = lesson;
};

const SET_TEACHBOT_LESSON = (state, lesson) => {
  state.teachbotLesson = lesson;
};

const GET_CATALOG = (state, catalog) => {
  if (catalog.mode === 'all' && catalog.page !== 0) {
    state.catalog.categories = state.catalog.categories.concat(
      catalog.categories,
    );
  } else {
    state.catalog.categories = catalog.categories;
  }
  if (catalog.next) {
    state.catalog.next = catalog.next;
  } else {
    state.catalog.next = null;
  }
};

const GET_EVALUATE_LESSON = (state, evaluateLesson) => {
  state.evaluateLesson = evaluateLesson;
};

const GET_LESSON_INFO = (state, lessonInfo) => {
  state.lessonInfo = lessonInfo;
};

const GET_EXPRESSION = (state, expression) => {
  state.expression = expression;
};

const GET_EXPRESSIONS = (state, expressions) => {
  state.expressions = expressions;
};

const GET_EXPRESSIONS_ALL = (state, response) => {
  const expressionsAll = response.response;
  const sortedHeaders = {
    unknown: {
      count: 0,
      title: '',
    },
    passive: {
      count: 0,
      title: '',
    },
    active: {
      count: 0,
      title: '',
    },
  };
  Object.entries(expressionsAll.headerInfo).forEach((item) => {
    if (item[0] === 'unknownExpressionCount') {
      sortedHeaders.unknown.count = item[1];
    }
    if (item[0] === 'unknownExpressionTitle') {
      sortedHeaders.unknown.title = item[1];
    }
    if (item[0] === 'passiveExpressionCount') {
      sortedHeaders.passive.count = item[1];
    }
    if (item[0] === 'passiveExpressionTitle') {
      sortedHeaders.passive.title = item[1];
    }
    if (item[0] === 'activeExpressionCount') {
      sortedHeaders.active.count = item[1];
    }
    if (item[0] === 'activeExpressionTitle') {
      sortedHeaders.active.title = item[1];
    }
  });
  // state.expressionsAll.headerInfo = sortedHeaders;
  Vue.set(state.expressionsAll, 'headerInfo', sortedHeaders);
  // state.expressionsAll.expressionTag = expressionsAll.expressionTag;
  Vue.set(state.expressionsAll, 'expressionTag', expressionsAll.expressionTag);
  // state.expressionsAll[response.category] = state.expressionsAll[response.category].concat(expressionsAll.expressions);
  Vue.set(
    state.expressionsAll,
    response.category,
    state.expressionsAll[response.category].concat(expressionsAll.expressions),
  );
  if (expressionsAll.next) {
    // state.expressionsAll.next = expressionsAll.next;
    Vue.set(state.expressionsAll, 'next', expressionsAll.next);
  }
};

const RESET_ALL_EXPRESSION = (state) => {
  state.expressionsAll = {
    unknown: [],
    passive: [],
    active: [],
  };
};

const GET_EXPRESSION_TAGS = (state, expressionTags) => {
  state.expressionTags = expressionTags;
};

const GET_WEEKLY_ENGLISH_LESSONS = (state, weeklyLessons) => {
  state.weeklyLessons = weeklyLessons;
};

const CURRENTLY_LOADED_ISLAND = (state, islandData) => {
  state.currentlyLoadedIslandWhereUserWas = islandData.island;
  state.currentlyLoadedIslandLevel = islandData.level;
};

const SET_FAVOURITE_EXPRESSION_IDS = (state, expression) => {
  state.favouritedExpressionIds[expression.id] = expression.favourite;
};

const SET_LANGUAGE_COLLISION = (state, value) => {
  state.languageCollison = value;
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

const SET_IS_SENDED_LANGUAGE_COLLISON_HEADER = (state, value) => {
  state.sendedLanguageCollisonHeader = value;
};
const SET_IS_CLASS_LANGUAGE_COLLISON = (state, value) => {
  state.isClassLanguageCollison = value;
};

export default {
  RESET_ALL_EXPRESSION,
  GET_ISLAND_PROGRESSION,
  GET_THEMATICS,
  GET_THEMATICS_BY_LEVEL,
  GET_LESSON,
  GET_EVALUATE_LESSON,
  GET_LESSON_INFO,
  GET_CATALOG,
  GET_EXPRESSION,
  GET_EXPRESSIONS,
  GET_EXPRESSIONS_ALL,
  GET_EXPRESSION_TAGS,
  GET_WEEKLY_ENGLISH_LESSONS,
  CURRENTLY_LOADED_ISLAND,
  GET_TRANSLATED_TEXT,
  GET_TRANSCRIBED_TEXT,
  GET_BOT_RESPONSE,
  GET_TEACHBOT_GROUPS_RESPONSE,
  GET_TEACHBOT_GROUPS_SKELETON_RESPONSE,
  GET_GRAMMAR_GROUPS_SKELETON_RESPONSE,
  GET_GRAMMAR_GROUPS_RESPONSE,
  SET_FAVOURITE_EXPRESSION_IDS,
  DESTROY,
  CLEAR_GRAMMAR_GROUPS,
  SET_TEACHBOT_LESSON,
  SET_LANGUAGE_COLLISION,
  SET_IS_SENDED_LANGUAGE_COLLISON_HEADER,
  SET_IS_CLASS_LANGUAGE_COLLISON,
};
